import type { ClaimGoogleTransLang, StreamStatus } from '@/domains/claim-charting/types/enum';
import type { TokenUsage } from './get-claim-feature-api';
import type { PsHttpSSE } from '@patsnap-utils/sse';

interface ClaimItem {
    name: string;
    separates: string[];
    indep_claim?: boolean;
}

export interface ApiGetClaimCompareResultRequest {
    // V1 参数（已废弃，保留向后兼容）
    claim_patent?: string;
    desc_patent?: string;
    claim_lang?: string;

    // V2 参数（使用 snake_case，后端自动转换为 camelCase）
    target_type?: 'patent' | 'freetext';
    target_patent_id?: string;
    target_content?: string;
    file_type?: 'patent' | 'freetext';
    file_patent_id?: string;
    file_content?: string;

    // 通用参数
    separate_claims: ClaimItem[];
}

export interface CompareItem {
    claim_feature: string;
    compare_feature: string;
    is_public: string;
    reason: string;
}

export interface CompareItems {
    name: string;
    separate_compare: CompareItem[];
    indep_claim?: boolean;
}

export interface CompareFeatureContent {
    desc_lang: ClaimGoogleTransLang;
    separate_compares: CompareItems[];
}

export interface ApiGetClaimCompareResultResponse {
    status: StreamStatus;
    token_usage: TokenUsage;
    content: CompareFeatureContent;
}

export const GetClaimCompareResult = Symbol.for('GetClaimCompareResult');

export interface GetClaimCompareResult {
    getClaimCompareResult(request: ApiGetClaimCompareResultRequest): PsHttpSSE<ApiGetClaimCompareResultResponse>;
}
